import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/de'

dayjs.extend(advancedFormat)
dayjs.extend(utc)

// English (British) format patterns - default
export const LongDateDisplayFormat = 'Do [of] MMMM YYYY'
export const LongDateTimeDisplayFormat = 'Do [of] MMMM YYYY h:mma'

// German format patterns
export const LongDateDisplayFormatDE = 'D. MMMM YYYY'
export const LongDateTimeDisplayFormatDE = 'D. MMMM YYYY H:mm'

// US English format patterns
export const LongDateDisplayFormatUS = 'MMMM D, YYYY'
export const LongDateTimeDisplayFormatUS = 'MMMM D, YYYY h:mma'

// Format patterns per locale (en = British default, de = German, us = US English)
const DateFormats: Record<string, { date: string, dateTime: string }> = {
  en: {
    date: LongDateDisplayFormat,
    dateTime: LongDateTimeDisplayFormat
  },
  de: {
    date: LongDateDisplayFormatDE,
    dateTime: LongDateTimeDisplayFormatDE
  },
  us: {
    date: LongDateDisplayFormatUS,
    dateTime: LongDateTimeDisplayFormatUS
  }
}

// Get formatted comparison date - shows time if same day as original, otherwise just date. Supports multiple locales (en = British, de = German, us = US English)
export function getDisplayComparisonDate (
  comparisonDateTime: string,
  originalDateTime: string,
  locale: string = 'en'
): string {
  const localeKey = locale.startsWith('de') ? 'de' : locale === 'us' ? 'us' : 'en'
  const formats = DateFormats[localeKey]
  const dayjsLocale = localeKey === 'us' ? 'en' : localeKey

  const comparisonDate = dayjs.utc(comparisonDateTime).locale(dayjsLocale)
  const originalDate = dayjs.utc(originalDateTime)

  if (comparisonDate.isSame(originalDate, 'day')) {
    return comparisonDate.format(formats.dateTime)
  }
  return comparisonDate.format(formats.date)
}
